import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import { useCallback } from 'react';
import { useRouteMatch } from 'react-router-dom';

/**
 * Returns a callback to notify when a report is run. Used by useReport to track
 * manual report runs in PostHog (skips the first run, then captures values and path).
 */
export function useReportCapture() {
  const capture = usePostHogCapture({ domain: 'reports' });
  const match = useRouteMatch();

  const notifyReportRun = useCallback(
    (values: object) => {
      capture('report_run', { report_path: match?.path, report_url: match?.url, values });
    },
    [capture, match?.path, match?.url],
  );

  return notifyReportRun;
}
